import { Text } from "@asayinc/component-library";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { TabulationItem } from "src/components/molecules/TabulationItem";
import { useTabulationReportsQuery } from "src/store/tabulation";

export function TabulationList() {
  const { id: proxyId } = useParams() as { id: string };
  const { data: tabulationReports } = useTabulationReportsQuery({ proxyId });

  if (!tabulationReports || tabulationReports?.count === 0) {
    return null;
  }

  return (
    <Stack sx={{ mb: 6 }} data-testid="tabulation-list">
      <Text sx={{ mb: 3 }} variant="subtitle2">
        Processed
      </Text>
      {tabulationReports?.results.map((report, index) => {
        return <TabulationItem key={index} tabulation={report} />;
      })}
    </Stack>
  );
}
